import Swan from "@swan-admin/swan-ai-measurements";
import { URLType } from "enum/enums";
import { REACT_APP_ACCESS_KEY } from "lib/Constants";

const swan = new Swan(REACT_APP_ACCESS_KEY||"",URLType.STAGING||"")

export default swan